import React, { useState, useContext } from "react";
import { MenuContainer } from "./styles";
import Menu from "components/Menu";
import { Burger } from "./styles";
import Login from "components/Login";
import Blur from "components/Blur";

import { AuthContext } from "contexts/AuthContext";

export default function NavBar({ overlay }) {
  const [open, setOpen] = useState(false);
  const { currentUserRoles, loading } = useContext(AuthContext);

  return (
    <>
      <MenuContainer role="full-horizontal">
        <Burger
          open={open}
          overlay={overlay}
          onMouseDown={(e) => e.nativeEvent.stopPropagation()}
          onClick={() => setOpen(!open)}
        >
          <div />
          <div />
          <div />
        </Burger>

        {open && <Blur />}


        <Menu
          open={open}
          loading={loading}
          roles={currentUserRoles}
          overlay={overlay}
          onClose={() => setOpen(false)}
        />


        <Login overlay={overlay} />
      </MenuContainer>
    </>
  );
}
